import React, { useContext, useEffect } from 'react';
import { Dropdown, Option } from '@fluentui/react-components';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { CallToActionOptions } from '@bingads-webui-campaign-react/linkedin-data';

import PropTypes from 'prop-types';

export const CallToAction = ({ selectedOption, onDataChange, setNewCTACallback }) => {
  const i18n = useContext(I18nContext);

  const { optionValue, optionText, selectedOptions } = selectedOption || {};

  useEffect(() => {
    if (setNewCTACallback) {
      setNewCTACallback(() => ({ CallToAction: cta }) => {
        const ctaOption = CallToActionOptions.find(option => option.key === cta);
        if (ctaOption) {
          const newCTA = {
            optionText: ctaOption.text,
            optionValue: ctaOption.key,
            selectedOptions: [ctaOption.key],
          };
          onDataChange({
            data: prevData => ({
              ...prevData,
              adData: {
                ...prevData.adData,
                CallToAction: newCTA,
              },
            }),
          });
        }
      });
    }
  }, [setNewCTACallback, onDataChange, i18n]);

  const onSelectedCallToActionChange = (event, data) => {
    onDataChange({
      data: prevData => ({
        ...prevData,
        adData: {
          ...prevData.adData,
          CallToAction: data,
        },
      }),
    });
  };

  return (
    <div className="call-to-action">
      <Dropdown
        className="call-to-action-dropdown"
        id={`select-call-to-action-${optionValue}`}
        placeholder={i18n.getString(_TL_('Select option'))}
        aria-label={i18n.getString(_TL_('Select option'))}
        onOptionSelect={onSelectedCallToActionChange}
        selectedOptions={selectedOptions}
        value={optionText ? i18n.getString(optionText) : ''}
        key={optionValue}
      >
        {CallToActionOptions.map(option => (
          <Option key={option.key} value={option.key} id={`option-${option.key}`}>
            {i18n.getString(option.text)}
          </Option>
      ))}
      </Dropdown>
    </div>
  );
};

CallToAction.propTypes = {
  selectedOption: PropTypes.string.isRequired,
  onDataChange: PropTypes.func.isRequired,
  setNewCTACallback: PropTypes.func,
};

CallToAction.defaultProps = { setNewCTACallback: null };
